import { Link } from "react-router-dom";
import logoLiveJoy from "../assets/logoLivejoy.svg";
import logoSuki from "../assets/sukilog.jpg";
import logoSalsa from "../assets/salsaLogo.png";
import "../styles/Aplicativos.css";

export default function Aplicativos() {
  return (
    <div className="aplicativos">
      <h1 className="aplicativos__titulo">Aplicativos</h1>
      <p className="aplicativos__intro">
        Manejamos diferentes aplicativos móviles los cuales podrás conocer a
        continuación para que trabajes en el que más se acomode a ti.
      </p>

      <section className="aplicativos__grid">
        <div className="aplicativos__card" to="/Aplicativos/Livejoy">
          <img
            src={logoLiveJoy}
            alt="Logo aplicación Livejoy"
            className="aplicativos__logo"
          />
          <h2 className="aplicativos__nombre">Livejoy</h2>
          <p className="aplicativos__descripcion">
            Es una aplicación que cuenta con 2 tipos de llamadas, Aleatoria y
            Directa, monitoreada los primeros 30 segundos de la llamada
            aleatoria. Puedes hacer transmisiones y obtener regalos de los
            usuarios que se suman a tus ganancias. Además hay tareas diarias y
            semanales que te ayudarán a aumentar tus ganancias.
          </p>
          <Link to="/Aplicativos/Livejoy" className="btn">
            Ver más
          </Link>
        </div>

        <div className="aplicativos__card">
          <img
            src={logoSuki}
            alt="Logo aplicación Suki"
            className="aplicativos__logo"
          />
          <h2 className="aplicativos__nombre">Suki</h2>
          <p className="aplicativos__descripcion">
            Aplicativo en el cual vas subiendo de nivel para aumentar la
            ganancia por minuto. Cuenta con transmisiones para atraer más
            usuarios a tu perfil, todas las llamadas son monitoreadas el primer
            minuto. También puedes aumentar tus ganancias con los regalos y las
            bonificaciones por tareas o por cumplimiento semanal.
          </p>
        </div>

        <div className="aplicativos__card">
          <img
            src={logoSalsa}
            alt="Logo aplicación Salsa"
            className="aplicativos__logo"
          />
          <h2 className="aplicativos__nombre">Salsa</h2>
          <p className="aplicativos__descripcion">
            Aplicativo que cuenta con llamada aleatoria la cual es monitoreada los
            primeros 30 segundos y una llamada directa que debe hacerte el usuario
            para obtener ganancias por minuto, también puedes atraer usuarios por
            medio de transmisiones y obtener regalos que aumentaran tus ganancias.
          </p>
        </div>
      </section>
    </div>
  );
}
